import { toast, Id } from 'react-toastify';
import { getRecoil } from 'recoil-nexus';
import { ToastMessageType } from 'src/constants/types';
import upperDataStore from 'src/stores/upperData';

let toastId: Id;

export const toastWrapper = (type: ToastMessageType, message: string, translationParams?: string | number) => {
  const { translate } = getRecoil(upperDataStore);

  const params = {
    icon: false,
    className: `toast-${type}-container`,
    type,
    closeButton: true,
    containerId: 'Betslip-Toastify'
  }

  const closeIcon = 'global-icon icon-toast-error';

  if (!toast.isActive(toastId))
    toastId = toast(<>
      <i className={closeIcon} />
      {translate(message, translationParams?.toString() || '')}
    </>, params);
};